import axios from "axios";

// ✅ Sirf .env se URL lega
const API_BASE_URL = process.env.REACT_APP_API_URL;

/* ================= PAYMENT METHODS ================= */
export const getPaymentMethods = async () => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}PaymentMethod/GetPaymentMethod`
    );

    console.log(
      "🔥 Payment Methods FULL RESPONSE:",
      res.data
    );

    const data =
      res.data?.data || res.data || [];

    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error(
      "getPaymentMethods Error:",
      err
    );

    return [];
  }
};

/* ================= WALLET BALANCE ================= */
export const getWalletBalance = async (
  customerId
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}WalletAPI/GetWalletByCustomerId`,
      {
        params: { customerId },
      }
    );

    console.log(
      "💰 Wallet API RAW:",
      res.data
    );

    return (
      res.data?.data?.currentBalance ??
      res.data?.currentBalance ??
      res.data ??
      0
    );
  } catch (err) {
    console.error(
      "getWalletBalance Error:",
      err
    );

    return 0;
  }
};

/* ================= FAMILY MEMBERS ================= */
export const getFamilyMembersByUserId =
  async (userId) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}Customer/GetFamilyMemberByUserId/${userId}`
      );

      console.log(
        "👨‍👩‍👧 Family Members:",
        res.data
      );

      return res.data || [];
    } catch (err) {
      console.error(
        "getFamilyMembersByUserId Error:",
        err
      );

      return [];
    }
  };

/* ================= GET CART ================= */
export const getCartByUserId = async (
  userId
) => {
  try {
    const res = await axios.get(
      `${API_BASE_URL}MasterAPI/GetCartByUserId`,
      {
        params: { userId },
      }
    );

    console.log(
      "🛒 Cart Response:",
      res.data
    );

    return res.data;
  } catch (err) {
    console.error(
      "getCartByUserId Error:",
      err
    );

    throw err;
  }
};

/* ================= GET USER ADDRESS ================= */
export const getUserAddressByUserId =
  async (userId) => {
    try {
      const res = await axios.get(
        `${API_BASE_URL}Customer/GetUserAddressByUserId/${userId}`
      );

      console.log(
        "📍 Address Response:",
        res.data
      );

      return res.data || [];
    } catch (err) {
      console.error(
        "getUserAddressByUserId Error:",
        err
      );

      throw err;
    }
  };

/* ================= PLACE ORDER ================= */
export const placeOrder = async (
  orderPayload
) => {
  try {
    console.log(
      "📦 ORDER PAYLOAD:",
      orderPayload
    );

    const res = await axios.post(
      `${API_BASE_URL}Order/CreateOrder`,
      orderPayload,
      {
        headers: {
          "Content-Type":
            "application/json",
        },
      }
    );

    console.log(
      "✅ Order Response:",
      res.data
    );

    return res.data;
  } catch (err) {
    console.error(
      "❌ placeOrder Error:",
      err?.response?.data || err
    );

    throw err;
  }
};

/* ================= DELETE CART ================= */
export const deleteCart = async (
  cartId
) => {
  try {
    const res = await axios.delete(
      `${API_BASE_URL}Cart/DeleteCart`,
      {
        params: { cartId },
      }
    );

    console.log(
      "🗑️ Cart Deleted:",
      res.data
    );

    return res.data;
  } catch (err) {
    console.error(
      "deleteCart Error:",
      err
    );

    throw err;
  }
};